// Local Server 111
// export const ServerIp = "104.197.0.113";
// export const LLServerIP = 'http://' + ServerIp + ':8084/';
// export const TSServerIP = 'http://' + ServerIp + ':8082/';
// export const FSServerIP = 'http://' + ServerIp + ':8086/';
// export const CAServerIP = 'http://' + ServerIp + ':8050/';
// export const CAServerID = "03516353-ae1d-d6d4-ec03-79038e6c0048";
// export const FSServerID = "ae81e547-eb4b-a577-0dcf-e1ccfc452b2d";
// export const LLServerID = "9b529067-53b9-52c6-d38e-b83c8660a29e";
// export const TSServerID = "d03124e4-92f6-8df0-c8d9-f082fb02aa31";
// // export const TaskManagementForumId = "10f15cce-f150-4ea9-8c6b-10bc0f69ac46";
// // export const TaskAdminForumId = "66703b95-fadf-4638-864b-f0dfb41ba195";
// export const TemplateId = "3e52fe33-5d73-8fdc-b1a2-9bd51f4dd320";
// export const TemplateName = "caEmailTrack1";
// export const ipDeployer = "http://34.29.134.84:80";
// export const FID = "305d1e09-3f5c-a157-7757-564942913a9e";

// Local Server
// export const LLServerIP = 'http://192.168.1.111:8084/';
// export const TSServerIP = 'http://192.168.1.111:8082/';
// export const FSServerIP = 'http://192.168.1.111:8086/';
// export const CAServerIP = "http://192.168.1.111:8050/";
// export const CAServerID = "20a307bd-3214-a3dd-5150-4efa13bb1589";
// export const FSServerID = "08f09a41-d239-bf86-25d9-5a69a215dc02";
// export const LLServerID = "0c7d1fb7-e094-79b7-d1ca-8e5c9abd9e84";
// export const TSServerID = "dd46c003-7088-adf7-ec07-d4b7a52ffb99";
// export const TemplateId = "7bdf7db7-4b50-3430-0b50-7bf68229b434";
// export const TemplateName = "emailTracker";
// export const FID = "305d1e09-3f5c-a157-7757-564942913a9e";
// export const bFID = "63767a32-bccf-fdc1-92df-bc718dfd41c2"
// export const ipDeployer = "http://192.168.1.111:8888";

// Production
export const LLServerIP = 'https://ll.cosmitude.com/';
export const TSServerIP = 'https://ts.cosmitude.com/';
export const FSServerIP = 'https://fs.cosmitude.com/';
export const CAServerIP = "https://ca.cosmitude.com/";
export const CAServerID = "c9b6722d-5dbf-4b4f-a28e-692b4d26c1cf-7870eb8e-2f45-458a-9a70-d6b2d71ee871";
export const FSServerID = "247366f9-f180-4c54-927d-0c008d07fff4-c8786a26-5320-439b-b0f7-aff6d1655525";
export const LLServerID = "f61eb7ea-3ff5-11e9-b210-d663bd873d93-085ac6ce-3ff6-11e9-b210-d663bd873d93";
export const TSServerID = "8ff836f8-4004-11e9-b210-d663bd873d93-b7359eae-4004-11e9-b210-d663bd873d93";
export const ipDeployer = "https://deployment.cosmitude.com";
// New Template
export const TemplateId = "85c37fff-15b0-c446-6e70-0d7ef0ecc76f";
export const TemplateName = "EmailTracker";
export const FID = "305d1e09-3f5c-a157-7757-564942913a9e";
export const bFID = "63767a32-bccf-fdc1-92df-bc718dfd41c2"
export const limitFID = "8851bf07-ef74-965d-ab10-41d5caa944ff"
// OldTemplate
// export const TemplateId = "e354ad5e-f14c-ffd5-f14f-c3bb4a217e0c";
// export const TemplateName = "emailTracker";
//
// export const TemplateId = "60e058ec-3a1f-126d-ae6f-515bdfbeb3e9";
// export const TemplateName = "caEmailTrack";
// export const FID = "305d1e09-3f5c-a157-7757-564942913a9e";
// // export const ipDeployer = "http://34.47.225.224:80";